// Utilitários puros do painel admin de White Labels — iniciais do
// logo, swatches do tema e busca client-side. (O agrupamento das
// configurações em seções virou FORM na wave 2 — ver
// components/configurations-tab.tsx e schemas.ts.)
import type {
  AdminWhiteLabelColors,
  AdminWhiteLabelListItem,
} from "@/types/admin-white-labels"

// Iniciais do fallback do logo (até 2 letras: "Empresa X" → "EX").
export const getInitials = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? "")
    .join("")

// Ordem canônica dos 5 swatches do tema (§6.1 do wireframe).
export const COLOR_KEYS = [
  "lineBackground",
  "buttonActionBackground",
  "buttonActionBackgroundHover",
  "buttonActionText",
  "background",
] as const
export type ColorKey = (typeof COLOR_KEYS)[number]

// Lista ordenada de swatches (cores ausentes ficam null — a UI
// renderiza o slot vazio p/ manter o alinhamento dos 5).
export const colorSwatches = (
  colors?: AdminWhiteLabelColors | null
): Array<{ key: ColorKey; value: string | null }> =>
  COLOR_KEYS.map((key) => ({
    key,
    value: colors?.[key] ?? null,
  }))

// Busca client-side sobre a página carregada: nome, slug OU loja.
export const filterWhiteLabels = (
  items: AdminWhiteLabelListItem[],
  search: string
): AdminWhiteLabelListItem[] => {
  const term = search.trim().toLowerCase()
  if (!term) return items
  return items.filter(
    (item) =>
      item.name.toLowerCase().includes(term) ||
      item.slug.toLowerCase().includes(term) ||
      (item.storeName ?? "").toLowerCase().includes(term)
  )
}
